import React, { HTMLProps, PropsWithChildren } from 'react';
import type { UrlObject } from 'url';

import styles from './nav-item.module.scss';
import { StyledLink } from './nav-item.styles';
import { classNameBuilder } from 'utils/classNameBuilder';

type NavItemProps = PropsWithChildren<{
  href: UrlObject | string;
  isOption?: boolean;
  selected?: boolean;
  shallow?: boolean;
  pictogram?: string;
  leftIconName?: string | false;
  rightIconName?: string | false;
  hasPictogram?: boolean;
  withPictogram?: boolean;
  firstLevel?: boolean;
  thirdLevel?: boolean;
  isOverviewItem?: boolean;
  notClickable?: boolean;
}> &
  HTMLProps<HTMLAnchorElement>;

export function NavItem({
  selected,
  pictogram,
  withPictogram,
  shallow,
  children,
  as,
  notClickable,
  ...anchorProps
}: NavItemProps) {
  return (
    <StyledLink
      shallow={shallow}
      className={classNameBuilder(styles.navItem, selected && 'selected')}
      selected={selected}
      $hasPictogram={withPictogram}
      $notClickable={notClickable}
      {...anchorProps}
    >
      {withPictogram && <div className="picto">{pictogram && <img src={pictogram} alt="" />}</div>}
      {children}
    </StyledLink>
  );
}
